import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=df8b8be2&"
import script from "./Whatsapp.vue?vue&type=script&lang=js&"
export * from "./Whatsapp.vue?vue&type=script&lang=js&"
import style0 from "./Whatsapp.vue?vue&type=style&index=0&id=df8b8be2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports